<template>
	<div class="container">
		<div class="row">
			<sidebar></sidebar>
			<div class="col-sm-10">
			<!-- Empty car-->
				<section class="account-section">
					<h2>Configuración</h2>
					<form class="form-horizontal config-form" role="form" @submit="update">
						<div class="row form-group">
						    <label class="control-label col-sm-3" for="name">Nombre</label>
						    <div class="col-sm-5 custom-width">
						      <input type="text" class="form-control" id="name" :class="{ 'has-error': err.name || err.name_msg }" v-model="render_user.name">
						      <div class="tooltip-error" v-if="err.name">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	Ingresa tu nombre para continuar.
						      </div>
						      <div class="tooltip-error" v-if="err.name_msg">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	{{ err.name_msg }}
						      </div>
						    </div>
					 	</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="last-name">Apellidos</label>
							<div class="col-sm-5 custom-width">
							  <input type="text" class="form-control" id="last-name" :class="{ 'has-error': err.last_name || err.last_name_msg}" v-model="render_user.last_name">
							  <div class="tooltip-error" v-if="err.last_name">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	Ingresa tu apellido para continuar.
						      </div>
						      <div class="tooltip-error" v-if="err.last_name_msg">
						      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
						      	{{ err.last_name_msg }}
						      </div>
							</div>
						</div>
						<div class="row form-group">
							<label class="control-label col-sm-3" for="phone">Teléfono</label>
							<div class="col-sm-5 custom-width">
							  <input type="text" class="form-control" id="phone" :class="{ 'has-error': err.phone || err.phone_msg}" v-model="render_user.phone">
							  <div class="tooltip-error" v-if="err.phone">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	Ingresa tu número de teléfono para continuar.
						      	</div>
						      	<div class="tooltip-error" v-if="err.phone_msg">
							      	<span class="top-caret"><i class="fa fa-play fa-rotate-180"></i></span>
							      	{{ err.phone_msg }}
							    </div>
							</div>
						</div>

						<div class="row form-group">
							<label class="control-label col-sm-3" for="birthday">Fecha de cumpleaños</label>

							<div class="col-sm-2 custom-width custom-padding-left">
								<div class="form-control control-select">
									<select class="select" id="month" v-model="render_user.month" @change="getDays">
									    <option value="1">Enero</option>
									    <option value="2">Febrero</option>
									    <option value="3">Marzo</option>
									    <option value="4">Abril</option>
									    <option value="5">Mayo</option>
									    <option value="6">Junio</option>
									    <option value="7">Julio</option>
									    <option value="8">Agosto</option>
									    <option value="9">Septiembre</option>
									    <option value="10">Octubre</option>
									    <option value="11">Noviembre</option>
									    <option value="12">Diciembre</option>
									</select>
									<i class="fa fa-caret-down select-caret"></i>
								</div>
							</div>	

							<label class="control-label col-sm-1 vh" style="padding-left:0; text-align: center">/</label>

							<div class="col-sm-2 custom-width custom-padding-right">
								<div class="form-control control-select">
									<select class="select" id="day" v-model="render_user.day">
									    <option v-for="n in days" :value="n + 1">{{ n + 1 }}</option>
									</select>
									<i class="fa fa-caret-down select-caret"></i>
								</div>
							</div>
							
							<i class="fa fa-question-circle vh" aria-hidden="true" data-toggle="tooltip" data-placement="right" title="Ingresa tu fecha de cumpleaños para recibir promociones (mm/dd)"></i>
						</div>

						<div class="row form-group"> 
						    <div class="col-sm-offset-3 col-sm-5">
						      <button type="submit" class="btn btn-black btn-lg">Guardar</button>
						    </div>
						</div>
					</form>
					
					<form v-if="render_user.is_wholesaler == 1" class="form-horizontal config-enterprise-form col-sm-7 col-sm-offset-1" role="form">
						<h3 class="text-uppercase">Datos de Empresa</h3> 
						<p class="admin-text">*Si deseas modificar estos datos, envía un correo a <a href="mailto:hola@lasddi.com" target="_top">hola@lasddi.com</a></p>
						<div class="row form-group">
							<p class="col-sm-offset-4 col-sm-8 legend-custom">Información de la empresa
							</p>
						</div>
							<div class="row form-group">
							    <label class="control-label col-sm-3" for="nombre_empresa">Nombre de la empresa*</label>
							    <div class="col-sm-9">
							    	<input type="text" class="form-control" v-model="render_user.nombre_empresa" disabled/>
							    </div>
					 		</div>
							
					 		<div class="row form-group">
							    <label class="control-label col-sm-3" for="nombre_representante">Nombre completo del representante*</label>
							    <div class="col-sm-9">
							    	<input type="text" class="form-control" v-model="render_user.nombre_representante" disabled/>
							    </div>
					 		</div>
					 		<div class="row form-group">
							    <label class="control-label col-sm-3" for="tipo_negocio">Tipo de negocio*</label>
							    <div class="col-sm-9">
							    	<input type="text" class="form-control" v-model="render_user.tipo_negocio" disabled/>
							    </div>
					 		</div>

					 		<!-- <div class="row form-group">
								<p class="col-sm-offset-4 col-sm-8 legend-custom">Verificación de la empresa
								</p>
							</div>
					 		<div class="row form-group">
							    <label class="control-label col-sm-3" for="location">Ubicación de la empresa*</label>
							    <div class="col-sm-9">
					        		<input type="text" class="form-control" v-model="render_user.location" disabled/>
							    </div>
					 		</div> -->

							<div class="row form-group">
								<p class="col-sm-offset-4 col-sm-8  legend-custom">Datos de Facturación</p>
							</div>
							<div class="form-group">
								<label class="control-label col-sm-3" for="business_name">Nombre o razón social*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.business_name" disabled/>
				        		</div>
							</div>
							<div class="row form-group">
								<label class="control-label col-sm-3" for="street">Calle*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.street" disabled/>
						      	</div>
							</div>
							<div class="row form-group">
								<label class="control-label col-sm-3" for="ext_number">N° Ext.*</label>
								<div class="col-sm-3">
									<input type="text" class="form-control" v-model="render_billing_info.ext_number" disabled/>
				        		</div>
				        		<label class="control-label col-sm-3" for="int_number">N° Int.</label>
								<div class="col-sm-3">
									<input type="text" class="form-control" v-model="render_billing_info.int_number" disabled/>
				        		</div>
							</div>
							
							<div class="row form-group">
								<label class="control-label col-sm-3" for="suburb">Colonia*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.suburb" disabled/>
						      	</div>
							</div>
							<div class="row form-group">
								<label class="control-label col-sm-3" for="postal_code">C.P.*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.postal_code" disabled/>
				        		</div>
							</div>
							<div class="row form-group">
								<label class="control-label col-sm-3" for="city">Ciudad*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.city_string" disabled/>
						      	</div>
							</div>
							<div class="row form-group">
								<label class="control-label col-sm-3" for="state">Estado*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.state_string" disabled/>
						      	</div>
							</div>
							<div class="row form-group">
							    <label class="control-label col-sm-3" for="rfc">RFC*</label>
							    <div class="col-sm-9">
						        	<input type="text" class="form-control" v-model="render_billing_info.rfc" disabled/>
							    </div>
					 		</div>
							<!-- <div class="row form-group">
								<label class="control-label col-sm-3" for="country">País*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.country" disabled/>
						      	</div>
							</div> -->
							<div class="row form-group">
								<label class="control-label col-sm-3" for="phone_number">Teléfono*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.phone_number" disabled/>
						      	</div>
							</div>
							<!-- <div class="row form-group">
								<label class="control-label col-sm-3" for="email2">Email*</label>
								<div class="col-sm-9">
									<input type="text" class="form-control" v-model="render_billing_info.email" disabled/>
						      	</div>
							</div> -->
						</div>
					</form>
				</section>
			</div>
		</div>
	</div>
</template>

<script>
import Breadcrumb from '../../components/User/Breadcrumb.vue';
import Sidebar from '../../components/User/Sidebar.vue';
import { updateMe } from '../../store/actions';
import { getDaysOfMonth } from '../../scripts/bisiesto';
import moment from 'moment';

var string_regexp = new RegExp(/[^\s0-9]+(\s+[^\s]+)*$/);
var phone_regexp = new RegExp(/^\d{10}$/);

const form = {
	business_name: '',
	street: '',
	ext_number: '',
	int_number: '',
	suburb: '',
	postal_code: '',
	city: '',
	state: '',
	phone_number: '',
	rfc: '',
	// email: '',
};

export default {
	// ---- DATA ----

	data() {
		return {
			form: {},
			has_error: true,
			msg_error: '',
			err: {},
			days: null
		}
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			user: state => state.current_user,
			user_info: state => state.current_user.user || {},
			states: state => state.states,
			billing_info: state => {
				let b = state.billing_info;

				for (let i = 0; i < b.length; i++) {
					if (b[i].rfc) {
						b[i].city_string = b[i].city.nom_mun;
						b[i].state_id = b[i].city.ent_id;
						return b[i];
					}
				}

				return form;
			}
		},
		actions: {
			updateMe
		}
	},

	// ---- RENDER ----

	computed: {
		render_user() {
			if (this.user_info.id) {
				let m = moment(this.user_info.birthday).format('MM');
				let d = moment(this.user_info.birthday).format('DD');
				this.days = getDaysOfMonth(m - 1);
				this.user_info.month = parseInt(m);
				this.user_info.day = parseInt(d);
			}

			return this.user_info;
		},

		render_billing_info () {
			if (this.billing_info.id) {
				let state = this.states[this.billing_info.state_id - 1];
				this.billing_info.state_string = state.nom_ent;
			}

			return this.billing_info;
		}
	},

	// ---- METHODS ----

	methods: {
		getDays () {
			this.user_info.day = null;
			this.days = getDaysOfMonth(this.user_info.month - 1);
		},

		update(e) {
			e.preventDefault();
			this.err = {};
			this.has_error = false;
			this.msg_error = '';

			this.form = {
				name: this.user_info.name,
				last_name: this.user_info.last_name,
				phone: this.user_info.phone,
				birthday: '2016-' + this.user_info.month + '-' + this.user_info.day,
				email: this.user_info.email,
				token: this.user.token
			};

			this.validate();

			if ($(window).width()<778){
				setTimeout( function(){
					$(".tooltip-error").css({"position": "initial", "margin-top" : "20px"});
					$(".top-caret").css({"display": "none"});
					$(".tooltip-error").addClass("center-block");
				}, 10);
			}

			if (this.has_error) {
				return;
			}

			this.updateMe(this.form);
		},

		validate() {
			for (var k in this.form) {
				if (!this.form[k]) {
					this.err[k] = true;
					this.has_error = true;
					//this.msg_error = 'No dejes campos vacíos.'
				}
			}
			
			if (!this.form.name.match(string_regexp) && !this.err.name)
			{
				this.err.name_msg = 'Ingresa únicamente letras para continuar.';
				this.has_error = true;
			}
			if (!this.form.last_name.match(string_regexp) && !this.err.last_name)
			{
				this.err.last_name_msg = 'Ingresa únicamente letras para continuar.';
				this.has_error = true;
			}
			if (!this.form.phone.match(phone_regexp) && !this.err.phone){
				this.err.phone_msg = 'Ingresa tu número a 10 dígitos para continuar.';
				this.has_error = true;
			}
		}
	},

	// ---- COMPONENTS ----
  
	components: {
		Breadcrumb,
		Sidebar,
	},
	// ---- READY ----

	ready: function() {
		// Init the tooltips.
		$('[data-toggle="tooltip"]').tooltip()
	}
};
</script>


// WEBPACK FOOTER //
// Config.vue?e08ff960